<div class="modal in hs-composition-share-dialog" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    <span>{{'COMPOSITIONS.dialogShare.shareMap' | translateHs }}</span> {{data.title}}
                </h4>
                <button type="button" (click)="close()" class="btn-close" data-dismiss="modal"
                    [attr.aria-label]="'COMMON.close' | translateHs ">
                </button>
            </div>
            <div class="modal-body" style="max-height: 600px; overflow-y: auto">
                <div class="row">
                    <div class="col-md-3"><b>{{'COMMON.abstract' | translateHs }}</b></div>
                    <div class="col-md-9">{{data.abstract}}</div>
                </div>
                <div class="row">
                    <div class="col-md-3"><b>{{'COMMON.url' | translateHs }}</b></div>
                    <div class="col-md-9"><a [href]="data.url">{{data.url}}</a></div>
                </div>
            </div>
            <div class="modal-footer">
                <div class="btn-group" role="group">
                    <button class="btn btn-secondary" (click)="shareOnSocial()">
                        <i class="icon-share-alt"></i> {{'COMMON.share' | translateHs }}
                    </button>
                </div>
                <button type="button" class="btn btn-secondary" (click)="close()" data-dismiss="modal">{{'COMMON.close'
                    | translateHs }}</button>
            </div>
        </div>
    </div>
</div>